<template>
    <v-container fluid class="footer03">
        <v-btn depressed v-if="phone != ''" class="button" :href="`tel:${phone}`">
            <i class="mdi mdi-phone"></i> Appeler
        </v-btn>
        <v-btn depressed class="button" @click="$router.push({ name: 'FollowUp', params: { code: code, id: lead.id } })">
            <i class="mdi mdi-hand-pointing-right"></i> Donner Suite
        </v-btn>
    </v-container>
</template>
<script>
export default {
    props: ['code', 'lead'],
    computed: {
        phone: function(){
            if(this.lead.telephone_mobile != ""){
                return this.lead.telephone_mobile
            } else if (this.lead.telephone_fixe != ""){
                return this.lead.telephone_fixe
            } else {
                return ""
            }
        },
    },
    methods: {
        goTo(routeName) {
            this.$store.dispatch('setLoader', true)
            this.$router.push({ name: routeName, params: { code: this.code } })
        }
    },
}
</script>
<style lang="scss">
    .footer03 {
        padding:0;
        height:8vh;
        position:fixed;
        bottom:0;
        display:flex;
        align-items:center;
        justify-content: space-around;
        background-color: white;
        z-index:4;
        border-top:2px solid #eb566b;
        .button {
            display:flex;
            justify-content:center;
            align-items: center;
            
            i {
                font-size:1.5em;
                margin-right:5px;
                color:#eb566b;
            }
        }
        
    }
</style>